 <div class="actions-container">
      <ng-container *ngIf="!isEditing">
        <button
          class="btn btn-outline-hover-primary btn-icon"
          (click)="onEditClick()"
          [disabled]="isAnyRowEditing && !isThisRowEditing"
          [class.disabled]="isAnyRowEditing && !isThisRowEditing"
          matTooltip="{{ 'data.COMMON.EDIT' | translate }}"
        >
          <i class="la la-edit"></i>
        </button>
      </ng-container>

      <ng-container *ngIf="isEditing">
        <button
          class="save-button"
          (click)="onSaveClick()"
          matTooltip="{{ 'data.COMMON.SAVE' | translate }}"
        >
          <mat-icon>check</mat-icon>
        </button>

        <button
          class="cancel-button"
          (click)="onCancelClick()"
          matTooltip="{{ 'data.COMMON.CANCEL' | translate }}"
        >
          <mat-icon>close</mat-icon>
        </button>
      </ng-container>
    </div>
